<template>
  <div class="connected" v-if="connected">
      Vous êtes maintenant connecté ! 
    <p class="connect-warning" v-if="analysts && analysts.length" style="color: #f3af48; margin-top: 25px; font-size: 1rem;">{{$t("dash.bots.analysts") + " " + analysts.join(", ")}}</p>
    <div class="interract">
      <button class="connect-btn" @click="confirmConnected">OK</button>
    </div>
  </div>
  <div ref="wrapper" v-else-if="page && awaitingApproval">
      <page-image-avatar class="avatar" :page="page"/>
      <p class="name">{{page.name}}</p>
      <div class="description">
          <p v-if="denied">{{$t("dash.bots.awaiting_approval_denied")}}</p>
          <p v-else>{{$t("dash.bots.awaiting_approval_instructions")}}</p>
      </div>
      <div class="interract">
        <button v-if="denied" class="connect-btn" @click="cancelApproval">{{$t("dash.bots.awaiting_approval_ok")}}</button>
        <button v-else class="connect-btn" @click="cancelApproval">{{$t("dash.button.cancel")}}</button>
      </div>
      <p v-if="error_response" class="error-return">{{error_response}}</p>
  </div>
  <div ref="wrapper" v-else-if="page && twoFactor">
      <page-image-avatar class="avatar" :page="page"/>
      <p class="name">{{page.name}}</p>
      <div class="description">
          <p v-if="twoFactor.verification_method == 0">
              Veuillez renseinger ci-dessous le code de verification recu sur l'application 
              vous permettant d'effectuer vos authentifications à deux facteurs et cliquez sur le bouton ci-dessous :
          </p>
          <p v-if="twoFactor.verification_method == 1">
              Veuillez renseinger ci-dessous le code de verification recu par SMS et cliquez sur le bouton ci-dessous :
          </p>
          <p v-if="twoFactor.verification_method == 4">
              Veuillez accepter l'appareil {{page.story_config.user_agent.split(';')[4]}} depuis la notification envoyée 
              par votre application Instagram et cliquez sur le bouton ci-dessous :
          </p>
          <p v-if="twoFactor.verification_method == 90">
              {{$t('dash.bots.two_factor_code_instagram')}}
              <strong v-if="twoFactor.delivery_hint" style="display: block; margin: 8px 0;">{{$t('dash.bots.two_factor_instagram_hint', {hint: twoFactor.delivery_hint})}}</strong>
          </p>
          <p v-if="twoFactor.verification_method == 99">
              Veuillez accepter l'appareil {{page.story_config.user_agent.split(';')[4]}} depuis la notification envoyée 
              par votre application Instagram ou entrer le code recu par SMS puis cliquez sur le bouton ci-dessous :
              (Si vous etes dans le cas d'une notification, laissez le champs ci-dessous vide)
          </p>
          <p v-if="twoFactor.verification_method == 98">
              Veuillez  entrer le code recu par Email ou SMS puis cliquez sur le bouton ci-dessous :
          </p>
      </div>
      <div class="interract">
        <input v-model="code" class="code" v-if="twoFactor.verification_method != 4" type="number">
        <button ref="connect-btn" @click="connectApi" class="connect-btn" :disabled="(twoFactor.verification_method != 4) && (!code)">Connecter</button>
        <div v-if="twoFactor.verification_method == 98"><p>{{$t("dash.pages.linkedin_code")}}</p><button class="connect-btn" @click="resendCode">{{$t("dash.pages.linkedin_code_btn")}}</button></div>
      </div>
      <p v-if="error_response" class="error-return">{{error_response}}</p>
      <p v-if="info_response" class="info-return">{{info_response}}</p>
  </div>
  <div ref="wrapper" v-else class="description">
      Erreur la page n'existe pas ou n'a pas besoin d'authentifiacation à deux facteurs.
  </div>
</template>

<script>

import PageImageAvatar from './PageImageAvatar.vue'
import Bots from '../mixins/Bots'
import Button from './utils/button.vue'

export default {

    props: {
        pageid: [String, Boolean],
        pages: Array,
        createPage: Boolean
    },
    data() {
        return {
            code: '',
            error_response: '',
            info_response: '',
            connected: false,
            analysts: [],
            pendingStoryConfig: null,
            pendingId: null,
            denied: false,
            pollIntervalId: null,
            pollStartedAt: null
        }
    },
    mixins: [Bots],
    components: {
        PageImageAvatar,
        Button
    },
    watch: {
        pages: function(val) {
            // this.$vs.loading.close(this.$refs.wrapper)
            // console.log("LES PAGES", this.page, this.twoFactor);
        },
        awaitingApproval: function(newVal) {
            if (newVal) {
                this.startPolling();
            } else {
                this.stopPolling();
            }
        }
    },
    mounted() {
        if (this.awaitingApproval) {
            this.startPolling();
        }
    },
    beforeDestroy() {
        this.stopPolling();
    },
    computed: {
        page() {
            if (!this.pages || this.pages.length === 0) return null;
            return this.pages.find(e => e.id === this.pageid);
        },

        awaitingApproval() {
            if (!this.page || !this.page.story_config) return false;
            const { awaitingApproval, two_factor } = this.page.story_config;
            return !!(awaitingApproval && !two_factor);
        },

        twoFactor() {
            if (!this.page || !this.page.story_config || (!this.page.story_config.two_factor && !this.page.story_config.checkpoint && !this.page.story_config.challenge_informations && !this.page.story_config.challenge)) return null;
            if (this.page.story_config.two_factor) {
                return JSON.parse(this.page.story_config.two_factor);
            }
            if (this.page.story_config.checkpoint) {
                return {verification_method: 99};
            }
            if (this.page.story_config.challenge_informations || this.page.story_config.challenge) {
                return {verification_method: 98};
            }
        }
    },
    methods: {

        connectApi() {
            this.info_response = '';
            this.error_response = '';
            if ((this.twoFactor.verification_method == 98 && this.code.length > 0) || this.code.length === 6 || this.twoFactor.verification_method == 4 || this.twoFactor.verification_method == 99 || this.twoFactor.verification_method == 90) {
                this.$vs.loading({container: this.$refs['connect-btn']})
                this.twoFactorLinkedinConnect({
                    verificationCode: this.code,
                    pageId: this.page.id,
                    createPage: this.createPage
                }).then(r => {
                    console.log(r);
                    this.$vs.loading.close(this.$refs['connect-btn']);
                    if (r.ok && r.body && r.body.connected) {
                        this.connected = true;
                        this.pendingStoryConfig = r.body.story_config || null;
                        this.pendingId = r.body.id || null;
                        if (r.body.analysts) {
                            this.analysts = r.body.analysts;
                        } else {
                            this.analysts = [];
                        }
                        this.$emit('getPagesEvent')
                    } else if (r.ok && r.body && r.body.badPin) {
                        this.error_response = this.$t("dash.pages.code_enter_incorrect");
                    } else {
                        this.error_response = `${r.status}: ${r.body[0] ? r.body[0].msg : r.bodyText}`
                    }
                })
            }
        },
        resendCode() {
            this.info_response = '';
            this.error_response = '';
            this.twoFactorLinkedinResendCode({
                pageId: this.page.id
            }).then(r => {
                console.log("twoFactorLinkedinResendCode",r);
                if (r.ok && r.body && r.body.success && r.body.resend) {
                    this.info_response = this.$t("dash.pages.linkedin_code_success");
                } else {
                    this.error_response = `${r.status}: ${r.body[0] ? r.body[0].msg : r.bodyText}`
                }
            })
        },

        startPolling() {
            this.stopPolling();
            this.denied = false;
            this.error_response = '';
            this.pollStartedAt = Date.now();
            this.pollApproval();
            this.pollIntervalId = setInterval(() => {
                this.pollApproval();
            }, 7500);
        },

        stopPolling() {
            if (this.pollIntervalId) {
                clearInterval(this.pollIntervalId);
                this.pollIntervalId = null;
            }
        },

        cancelApproval() {
            this.stopPolling();
            this.$emit('closePopup');
        },

        confirmConnected() {
            this.$emit('closePopup', { story_config: this.pendingStoryConfig, id: this.pendingId });
        },

        async pollApproval() {
            // Give up after a few minutes if the other device never responds.
            if (Date.now() - this.pollStartedAt > 3 * 60 * 1000) {
                this.stopPolling();
                this.error_response = this.$t("dash.bots.awaiting_approval_timeout");
                return;
            }

            // Completing an approval takes longer than the interval - an overlapping poll
            // would replay the already-used approval and report an error.
            if (this.pollInFlight) return;
            this.pollInFlight = true;
            try {
                const r = await this.checkTwoAuthApproval({ pageId: this.page.id });

                if (r.ok && r.body && r.body.connected) {
                    this.stopPolling();
                    this.connected = true;
                    this.pendingStoryConfig = r.body.story_config || null;
                    this.pendingId = r.body.id || null;
                    this.analysts = r.body.analysts || [];
                    this.$emit('getPagesEvent');
                } else if (r.ok && r.body && r.body.denied) {
                    this.stopPolling();
                    this.denied = true;
                } else if (r.ok && r.body && r.body.pending) {
                    // Still waiting - the interval will check again.
                } else {
                    this.stopPolling();
                    this.error_response = `${r.status}: ${r.body && r.body[0] ? r.body[0].msg : r.bodyText}`;
                }
            } catch (e) {
                console.error('[TwoFactorAuthenticationPopup] Error checking approval status:', e);
                // Transient network error - skip this tick rather than aborting the whole wait.
            } finally {
                this.pollInFlight = false;
            }
        }
    }

}
</script>
